import { Action, createReducer, on } from "@ngrx/store";

import * as ProductLocatorActions from "./product-locator.actions";
import {
    initialProductLocatorState,
    ProductLocatorState,
} from "./product-locator.state";

export const PRODUCT_LOCATOR_FEATURE_KEY = "productLocator";

const resetProductLocatorReducer = (): ProductLocatorState => ({
    shopsStock: {},
    error: undefined,
    status: "uninitialized",
});

const fetchShopsStockReducer = (
    state: ProductLocatorState,
): ProductLocatorState => ({
    ...state,
    status: "loading",
});

const fetchShopsStockSuccessReducer = (
    state: ProductLocatorState,
    action: ReturnType<typeof ProductLocatorActions.fetchShopsStockSuccess>,
): ProductLocatorState => ({
    ...state,
    status: "loaded",
    shopsStock: action.shopsStock,
});

const fetchShopsStockFailureReducer = (
    state: ProductLocatorState,
    action: ReturnType<typeof ProductLocatorActions.fetchShopsStockFailure>,
): ProductLocatorState => ({
    ...state,
    status: "error",
    error: action.errorMessage,
});

const productLocatorReducer = createReducer(
    initialProductLocatorState,
    on(ProductLocatorActions.fetchShopsStock, fetchShopsStockReducer),
    on(
        ProductLocatorActions.fetchShopsStockSuccess,
        fetchShopsStockSuccessReducer,
    ),
    on(
        ProductLocatorActions.fetchShopsStockFailure,
        fetchShopsStockFailureReducer,
    ),
    on(ProductLocatorActions.resetProductLocator, resetProductLocatorReducer),
    on(ProductLocatorActions.launchProductLocator, resetProductLocatorReducer),
);

export const reducer = (
    state: ProductLocatorState,
    action: Action,
): ProductLocatorState => productLocatorReducer(state, action);
